import React from "react";
import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";

const Sidebar = ({ folders, onNavigate, currentFolder }) => (
  <Paper
    elevation={1}
    sx={{
      width: 250,
      height: "100%",
      p: 2,
      borderRadius: 2,
      bgcolor: "#f9fafb",
      overflowY: "auto",
    }}
  >
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      mb={2}
      sx={{ color: "#374151" }}
    >
      File Explorer
    </Typography>

    <List disablePadding>
      {folders.map((folder) => (
        <ListItem
          key={folder}
          onClick={() => onNavigate(folder)}
          sx={{
            mb: 1,
            borderRadius: 2,
            px: 2,
            py: 1,
            cursor: "pointer",
            bgcolor:
              currentFolder === folder ? "#e0f2fe" : "transparent",
            "&:hover": {
              bgcolor: "#f1f5f9",
            },
            transition: "0.2s ease",
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <FolderIcon
              sx={{
                color: currentFolder === folder ? "#3b82f6" : "#6b7280",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="body2"
                sx={{
                  color: currentFolder === folder ? "#1d4ed8" : "#374151",
                  fontWeight: currentFolder === folder ? 600 : 400,
                }}
              >
                {folder}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  </Paper>
);

export default Sidebar;
